export const workflowRoutes = {
  root: '/workflow',
  workflow: (token: string) => `/workflows/${token}` as const,
  workflowVersion: (token: string) => `/workflow/${token}/version` as const,
} as const;
